export enum FlagNames {
    SHOW_ALTERNATIVE_NEWGAME_PRELOADER = 'showAlternativeNewgamePreloader',
    SHOW_NEWGAME_PRELOADER_FOR_ALL = 'showNewgamePreloaderForAll',
    SHOW_RU_TETHER_SOCIAL_NOTIFY = 'showRuTetherSocialNotify',
    AB_TEST_LP_ONE_TAP = 'abTestLpGoogleOneTap',
    WEB_GUEST_ACCOUNTS = 'guestAccounts',
    WEB_S3_ASSETS = 'webS3Assets',
    LP_S3_ASSETS = 'lpS3Assets',
    LP_DIRECTORIES = 'lpDirectories',
    WEB_CHAT_SUPPORT = 'webChatSupport',
    DISABLE_WEB_GUEST_ACCOUNT_WARNING = 'disableWebGuestAccountWarning',
    WEB_APPLE_ID_LOGIN = 'webAppleIdLogin',
    REGISTRATION_NO_DUPLICATES = 'registrationNoDuplicates',
    GET_USER_NO_DUPLICATES = 'getUserNoDuplicates',
    SHOW_REAL_LOADING_PERCENTS = 'showRealLoadingPercents',
    FINGERPRINT_ENABLED = 'fingerprintEnabled',
    CLIENT_DEATH_TIMER_ENABLED = 'clientDeathTimerEnabled',
}
